var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9585 2.29169V17.7084H16.0418V4.84224L13.4913 2.29169H3.9585ZM2.7085 2.16669C2.7085 1.54537 3.21218 1.04169 3.8335 1.04169H13.5431C13.8414 1.04169 14.1276 1.16021 14.3386 1.37119L16.9623 3.99497C17.1733 4.20594 17.2918 4.49209 17.2918 4.79046V17.8334C17.2918 18.4547 16.7881 18.9584 16.1668 18.9584H3.8335C3.21217 18.9584 2.7085 18.4547 2.7085 17.8334V2.16669Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04183 8.33335C6.04183 7.98818 6.32165 7.70835 6.66683 7.70835L13.3335 7.70835C13.6787 7.70835 13.9585 7.98818 13.9585 8.33335C13.9585 8.67853 13.6787 8.95835 13.3335 8.95835L6.66683 8.95835C6.32165 8.95835 6.04183 8.67853 6.04183 8.33335Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04183 15C6.04183 14.6548 6.32165 14.375 6.66683 14.375H13.3335C13.6787 14.375 13.9585 14.6548 13.9585 15C13.9585 15.3452 13.6787 15.625 13.3335 15.625H6.66683C6.32165 15.625 6.04183 15.3452 6.04183 15Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04183 11.6667C6.04183 11.3215 6.32165 11.0417 6.66683 11.0417H10.0002C10.3453 11.0417 10.6252 11.3215 10.6252 11.6667C10.6252 12.0119 10.3453 12.2917 10.0002 12.2917H6.66683C6.32165 12.2917 6.04183 12.0119 6.04183 11.6667Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 1.04169C13.6787 1.04169 13.9585 1.32151 13.9585 1.66669V4.37502H16.6668C17.012 4.37502 17.2918 4.65484 17.2918 5.00002C17.2918 5.3452 17.012 5.62502 16.6668 5.62502H13.8335C13.2122 5.62502 12.7085 5.12134 12.7085 4.50002V1.66669C12.7085 1.32151 12.9883 1.04169 13.3335 1.04169Z",
    fill: "#9897A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDocument);
export default __webpack_public_path__ + "static/media/delete-document.295b70929b531051dd2a7085afff91fc.svg";
export { ForwardRef as ReactComponent };